import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import FTSocket, { MESSAGE_CUTOFF, MESSAGE_MAX } from "./SocketController";
import MessageHolder from "./MessageHolder";

export default function FTNavMessage(props){
	let [isShowingMessages, setShow] = useState(false)
		, [totalMessages, setTotal] = useState(0)
		, [hasLoadingMessage, setLoading] = useState(false)
		, navMessageRef = useRef(null)
		, messageCount = totalMessages
		, $messages = null
		, $badge = null
		, title = `${totalMessages} unread Messages`
		, icon = "ft-ic fas fa-bell"
		;

	function onMessage(evt){
		let total = props.socketInstance.unread;

		let isLoading = props.socketInstance.messages.some((v) => {
			// If the message is read, don't use it to check for `isLoading`
			if(v.isRead){ return false; }

			return /in progress/gi.test(v?.info?.status);
		});

		if(props.__debug){
			let msg = evt.detail.message;
			/* eslint-disable */
			console.groupCollapsed("%c  WebSocket Debugging  \%c", "font-weight:bold; color:#2d7ebf; text-decoration:underline;", "font-weight:normal; color:#000; text-decoration:none;");
				console.info("Debugging from %cNavMessag%c","font-weight:bold; color:#c76eff;", "font-weight:normal; color:#000");
				console.log("Full message from Socket:");
				console.dir(evt.detail.message);
				console.table({
					topic:evt.detail.topicName,
					task: msg.task,
					status:msg.status,
					origin:msg.origin,
				});
			console.groupEnd();
			/* eslint-enable */
		}
		setTotal(total);
		setLoading(isLoading);
	}
	// We only want to set this addEventListener up once
	useEffect(() => {
		window.addEventListener("onFTMessage", onMessage);
		return function cleanup(){
			try {
				window.removeEventListener("onFTMessage", onMessage);
			} catch(err){}
		};
	}, []);

	useEffect(() => {
		function handler(e){
			const node = document.getElementById(props.domNode);

			// If we're clicking outside the message holder, or the bell icon section, hide the panel
			if(!node.contains(e.target) && !navMessageRef.current.contains(e.target)){
				setShow(false);
			}
		}

		document.addEventListener("click", handler, true);

		return () => {
			document.removeEventListener("click", handler, true);
		};
	}, [props.domNode, navMessageRef.current, setShow]);

	if(totalMessages){
		if(totalMessages > MESSAGE_CUTOFF){
			messageCount = MESSAGE_MAX;
		}
		$badge = <span className="unread-count">{messageCount}</span>;
	}

	if(hasLoadingMessage){
		icon = "ft-ic fas fa-sync-alt is-loading-something";
	}

	if(isShowingMessages){
		$messages = <MessageHolder domNode={props.domNode} socketInstance={props.socketInstance} />;
	}

	return (
		<div
			className={`${props.classes} nav-message`}
			onClick={e => setShow(!isShowingMessages)}
			title={title}
			ref={navMessageRef}
		>
			<i className={icon} />
			{$badge}
			{$messages}
		</div>
	);
}

FTNavMessage.displayName = "FlashTalkingNavMessage";
FTNavMessage.defaultProps = {
	__debug:false,
};
FTNavMessage.propTypes = {
	domNode:PropTypes.string.isRequired,
	socketInstance:PropTypes.instanceOf(FTSocket).isRequired,
	__debug:PropTypes.bool,
};
